<div class="region-info">
    <div class="region-info__content">
        <div class="region-info__map" #locationsRef>
            @if (!isFetching) {
                <app-simple-map
                        [coordinates]="countryInfoParseService.mapCoordinates$ | async | parseCoordinates"
                ></app-simple-map>
            } @else {
                <ngx-skeleton-loader
                        [theme]="{height: locationsRef.clientHeight + 'px', margin: 0}"></ngx-skeleton-loader>
            }
        </div>
        <div class="region-info__items">
            <div class="region-info__breadcrumbs">
                <app-simple-breadcrumb [breadcrumbs]="breadcrumbs"></app-simple-breadcrumb>
            </div>

            <div class="region-info__details">
                <h2>About {{ defaultLocationName | replaceStr: ' ' | titlecase }}</h2>
                @if (!isFetching) {
                    <app-text-ellipsis
                            [short]="regionResponse.cityInfo.getFirstCity().shortDescription"
                            [long]="regionResponse.cityInfo.getFirstCity().description"
                            [extra]="regionResponse.cityInfo.getFirstCity().extraDescription"
                    ></app-text-ellipsis>
                } @else {
                    <ngx-skeleton-loader [theme]="{height: '16px', margin: 0}"></ngx-skeleton-loader>
                    <ngx-skeleton-loader [theme]="{height: '16px', margin: 0, marginTop: '7px'}"></ngx-skeleton-loader>
                    <ngx-skeleton-loader [theme]="{height: '16px', margin: 0, marginTop: '7px'}"></ngx-skeleton-loader>
                }
            </div>

            <app-gallery-mobile
                    [destinations]="regionDetails.destinations"
                    (selectedItem)="flyToGalleryItem($event)"
            ></app-gallery-mobile>

            @if (countryResponse?.regionsSearchedAndSorted?.length || isFetching) {
                <app-region-list-mobile
                        [isFetching]="isFetching"
                        [selectedRegionId]="regionDetails.id || 'fetching'"
                        [countryName]="countryDetails.name"
                        [regions]="countryResponse.regionsSearchedAndSorted"
                ></app-region-list-mobile>
            }

            @if (countryResponse.itineraries?.length || isFetching) {
                <app-itinerary-list-mobile
                        [isFetching]="isFetching"
                        [countryName]="countryDetails.name"
                        [itineraries]="countryResponse.itineraries"
                ></app-itinerary-list-mobile>
            }
        </div>
    </div>

    <div class="region-info__footer">
        <app-start-planing-mobile></app-start-planing-mobile>
    </div>
</div>
